/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_LinkInputs */

const en_tables_custom_properties_link = /** @type {(inputs: Tables_Custom_Properties_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Link`)
};

const de_tables_custom_properties_link = /** @type {(inputs: Tables_Custom_Properties_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

/**
* | output |
* | --- |
* | "Properties Link" |
*
* @param {Tables_Custom_Properties_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_link = /** @type {((inputs?: Tables_Custom_Properties_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_link(inputs)
	return de_tables_custom_properties_link(inputs)
});